import { GoTools } from "react-icons/go";
import { FcInvite } from "react-icons/fc";
import { Collapse, ListGroup } from "react-bootstrap";
import { TbCategory } from "react-icons/tb";
import { CiMenuKebab } from "react-icons/ci";
import { useEffect, useRef, useState } from "react";
import { BsJournalPlus, BsShieldLock } from "react-icons/bs";
import { groupServices } from "../APIServices/PasswordManagement/groupServices";
import { LuActivity, LuShieldAlert, LuShieldCheck } from "react-icons/lu";
import { CgArrowTopRightR, CgArrowTopLeftR } from "react-icons/cg";
import { FaEdit, FaStar, FaUsers } from "react-icons/fa";
import { MdOutlineCategory } from "react-icons/md";
import { RiAlignItemLeftFill, RiArrowDownWideLine, RiArrowRightWideFill } from "react-icons/ri";
import { VscHistory } from "react-icons/vsc";
import Swal from "sweetalert2";
import UseToggle from "../Hooks/UseToggle";
import AddGroup from "./GroupManagement/AddGroup";
import UpdateGroup from "./GroupManagement/UpdateGroup";
import GroupShareWithMember from "./GroupManagement/GroupShareWithMember";
import DeletedGroups from "./GroupManagement/DeletedGroups";
import UpdatedActivity from "./ItemManagement/UpdatedActivity";
import { AiOutlineAudit } from "react-icons/ai";
import { IoArchiveOutline } from "react-icons/io5";
import { FaRegTrashCan } from "react-icons/fa6";
import { TfiShare } from "react-icons/tfi";
import { sharedServices } from "../APIServices/PasswordManagement/sharedServices";
import ShareList from "./GroupManagement/ShareList";

const Sidebar = ({
  auth,
  activeItem,
  setActiveItem,
  setGroupId,
  groupId,
  isDark,
  plateformSettings,
  categoryList,
  setCategoryId,
  groupList,
  setUpdator,
  groupData,
  currentUserData
}) => {
  const toggles = UseToggle();
  const menuRef = useRef(null);

  const [openGroup, setOpenGroup] = useState(false);
  const [openShareWithMeData, setOpenShareWithMeData] = useState(false);
  const [openSharedByMeData, setOpenSharedByMeData] = useState(false);
  const [openGroupOption, setOpenGroupOption] = useState("");

  const [sharedWithMeGroupList, setSharedWithMeGroupList] = useState([]);
  const [sharedByMeGroupList, setSharedByMeGroupList] = useState([]);
  const [deletedGroupList, setDeletedGroupList] = useState([]);
  const [deletedGroupCount, setDeletedGroupCount] = useState(0);

  const getSharedWithMeGroupList = async () => {
    const res = await sharedServices.getSharedWithMeGroupList(auth);
    setSharedWithMeGroupList(res?.data || []);
  };

  const getSharedByMeGroupList = async () => {
    const res = await sharedServices.getSharedByMeGroupList(auth);
    setSharedByMeGroupList(res?.data || []);
  };

  const getDeletedGroupList = async () => {
    const res = await groupServices.getGroupList(auth, "deleted");
    setDeletedGroupList(res?.data || []);
    setDeletedGroupCount(res.count || 0)
  };

  const softDeleteRestoreGroup = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} this Group?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      const userData = { groupId: id, type };
      const data = await groupServices.softDeleteRestoreGroup(auth, userData);
      if (data?.statusCode === 200) {
        setUpdator(`groupList_${Math.floor(10000 + Math.random() * 90000)}`);
        getDeletedGroupList();
        if (groupId === id) {
          setActiveItem("all");
          setGroupId("all");
          setCategoryId("")
        }
      }
    });
  };

  const deleteGroup = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to permanent delete this group?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, permanent delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await groupServices.deleteGroup(auth, { groupId: id });
        if (res?.statusCode === 200) {
          getDeletedGroupList();
        }
      }
    });
  };

  useEffect(() => {
    getSharedWithMeGroupList()
    getSharedByMeGroupList()
    getDeletedGroupList()
  }, [auth, activeItem]);

  useEffect(() => {
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenGroupOption("");
      }
    };
    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, []);

  return (
    <aside className="sidebar-container">
      {!plateformSettings?.settings?.sidebarSettings?.quickAccess &&
        <>
          <div className="sidebar-section-title">{`Quick Access`}</div>
          <div className="sidebar-list">
            {!plateformSettings?.settings?.sidebarSettings?.allItems &&
              <div onClick={() => { setActiveItem("all"); setGroupId("all"); setCategoryId("") }}
                className={`sidebar-item ${activeItem === "all" && groupId === "all" ? "active" : ""}`}>
                <RiAlignItemLeftFill /> All Items
              </div>
            }
            {(!plateformSettings?.settings?.sidebarSettings?.favorites && !plateformSettings?.settings?.showSidebarSettings?.favorites) &&
              <div onClick={() => { setActiveItem("bookmark"); setGroupId("bookmark"); setCategoryId("") }}
                className={`sidebar-item ${activeItem === "bookmark" ? "active" : ""}`}>
                <FaStar className="text-warning" /> Favorites
              </div>
            }
            {!plateformSettings?.settings?.sidebarSettings?.secureScan &&
              <div onClick={() => { setActiveItem("secureScan"); setGroupId(""); setCategoryId("") }}
                className={`sidebar-item ${activeItem === "secureScan" ? "active" : ""}`}>
                <LuShieldCheck /> Secure Scan
              </div>
            }
            {!plateformSettings?.settings?.sidebarSettings?.secureEye &&
              <div onClick={() => { setActiveItem("secureEye"); setGroupId(""); setCategoryId("") }}
                className={`sidebar-item ${activeItem === "secureEye" ? "active" : ""}`}>
                <LuShieldAlert /> Secure Eye
              </div>
            }
            {!plateformSettings?.settings?.sidebarSettings?.tools &&
              <div onClick={() => { setActiveItem("tools"); setGroupId(""); setCategoryId("") }}
                className={`sidebar-item ${activeItem === "tools" ? "active" : ""}`}>
                <GoTools /> Tools
              </div>
            }
          </div>
        </>
      }
      {!plateformSettings?.settings?.sidebarSettings?.collaboration &&
        <>
          <div className="sidebar-section-title hstack gap-2">{`Collaboration`}</div>
          <div className="sidebar-list">
            {(!plateformSettings?.settings?.sidebarSettings?.member && currentUserData?.loginAccountId) &&
              <div onClick={() => { setActiveItem("members"); setGroupId(""); setCategoryId("") }}
                className={`sidebar-item ${activeItem === "members" ? "active" : ""}`}>
                <FaUsers /> Members
              </div>
            }
            {!plateformSettings?.settings?.sidebarSettings?.invitedMember &&
              <>
                {currentUserData?.roleType === "organization" ?
                  <div onClick={() => { setActiveItem("inviteMembers"); setGroupId(""); setCategoryId("") }}
                    className={`sidebar-item ${activeItem === "inviteMembers" ? "active" : ""}`}>
                    <FcInvite /> Invitation
                  </div>
                  :
                  <div onClick={() => { setActiveItem("invitedMe"); setGroupId(""); setCategoryId("") }}
                    className={`sidebar-item ${activeItem === "invitedMe" ? "active" : ""}`}>
                    <FcInvite /> Invitation
                  </div>
                }
              </>
            }
          </div>
        </>
      }
      {!plateformSettings?.settings?.sidebarSettings?.category && categoryList?.length > 0 &&
        <>
          <div className="sidebar-section-title">{`Categories`}</div>
          <div className="sidebar-list">
            {categoryList.map((category, index) => (
              <div key={index} onClick={() => { setActiveItem(category?.key); setGroupId("all"); setCategoryId(category?.key); }}
                className={`sidebar-item ${activeItem === category?.key ? "active" : ""}`}>
                <img src={category?.icon} alt={category?.name} width={12} height={12} /> {category?.name}
              </div>
            ))}
          </div>
        </>
      }
      {!plateformSettings?.settings?.sidebarSettings?.vaults &&
        <>
          <div className="sidebar-section-title">{`Vaults`}</div>
          <div className="sidebar-list">
            {!plateformSettings?.settings?.sidebarSettings?.personal &&
              <div onClick={() => { setActiveItem("personal"); setGroupId("personal"); setCategoryId("") }}
                className={`sidebar-item ${groupId === "personal" ? "active" : ""}`}>
                <BsShieldLock /> Personal
              </div>
            }
            {currentUserData?.loginAccountId &&
              <>
                {!plateformSettings?.settings?.sidebarSettings?.group &&
                  <div className="sidebar-item hstack justify-content-between"
                    onClick={() => setOpenGroup(!openGroup)}>
                    <div className="hstack gap-2">
                      <TbCategory /> Groups
                      <BsJournalPlus
                        onClick={(e) => {
                          e.stopPropagation();
                          toggles.setToggle();
                        }}
                      />
                    </div>
                    {groupList?.length > 0 && (openGroup ? <RiArrowDownWideLine /> : <RiArrowRightWideFill />)}
                  </div>
                }
                <Collapse in={openGroup}>
                  <div className={groupList?.length > 0 && "ms-3"}>
                    {groupList.map((g) => (
                      <div key={g.groupId}
                        className={`group-item ${((activeItem === "groups") && (groupId === g.groupId)) ? "active" : ""}`}
                        onClick={() => {
                          setActiveItem("groups");
                          setGroupId(g.groupId);
                          setCategoryId("")
                        }}>
                        <span><MdOutlineCategory /> {g.groupName}</span>

                        <div ref={menuRef} className="position-relative">
                          <CiMenuKebab
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenGroupOption(
                                openGroupOption === g.groupId ? "" : g.groupId
                              );
                            }}
                          />

                          <Collapse in={openGroupOption === g.groupId}>
                            <ListGroup className="position-absolute z-1" style={{ top: 26, right: -10, fontSize: 12, width: 110 }}>
                              <ListGroup.Item action title="Update" className="hstack gap-2 py-1 px-3" onClick={() => { toggles.setToggle1(); setGroupId(g.groupId); }}>
                                <FaEdit /> Update
                              </ListGroup.Item>
                              <ListGroup.Item action title="Share" className="hstack gap-2 py-1 px-3" onClick={() => { toggles.setToggle2(); setGroupId(g.groupId); }}>
                                <TfiShare /> Share
                              </ListGroup.Item>
                              <ListGroup.Item action title="Share List" className="hstack gap-2 py-1 px-3" onClick={() => { toggles.setToggle5(); setGroupId(g.groupId); }}>
                                <VscHistory /> Share List
                              </ListGroup.Item>
                              <ListGroup.Item action title="Activity" className="hstack gap-2 py-1 px-3" onClick={() => toggles.setToggle4()}>
                                <LuActivity /> Activity
                              </ListGroup.Item>
                              <ListGroup.Item action title="Delete" className="hstack gap-2 py-1 px-3 text-danger"
                                onClick={() => softDeleteRestoreGroup(g.groupId, "delete")}>
                                <FaRegTrashCan /> Delete
                              </ListGroup.Item>
                            </ListGroup>
                          </Collapse>
                        </div>
                      </div>
                    ))}
                    {deletedGroupCount > 0 &&
                      <>
                        <div
                          className={`group-item text-danger`}
                          onClick={() => toggles.setToggle3()}>
                          <span><MdOutlineCategory /> Deleted Group</span>
                        </div>
                      </>
                    }
                  </div>
                </Collapse>
              </>
            }
            {!plateformSettings?.settings?.sidebarSettings?.sharedWithMe &&
              <div className="sidebar-item hstack justify-content-between"
                onClick={() => setOpenShareWithMeData(!openShareWithMeData)}>
                <div className="hstack gap-2">
                  <CgArrowTopRightR /> Shared with me
                </div>
                {openShareWithMeData ? <RiArrowDownWideLine /> : <RiArrowRightWideFill />}
              </div>
            }
            <Collapse in={openShareWithMeData}>
              <div className="ms-3">
                <div
                  className={`group-item ${groupId === "sharedWithMe" ? "active" : ""}`}
                  onClick={() => {
                    setActiveItem("sharedWithMe");
                    setGroupId("sharedWithMe");
                    setCategoryId("")
                  }}>
                  <span><BsShieldLock /> Vaults</span>
                </div>
                {currentUserData?.loginAccountId &&
                  <>
                    {sharedWithMeGroupList.map((g) => (
                      <div key={g.groupId}
                        className={`group-item ${((activeItem === "sharedWithMeGroups") && (groupId === g.groupId)) ? "active" : ""}`}
                        onClick={() => {
                          setActiveItem("sharedWithMeGroups");
                          setGroupId(g.groupId);
                          setCategoryId("")
                        }}>
                        <span><MdOutlineCategory /> {g.groupName}</span>
                      </div>
                    ))}
                  </>
                }
              </div>
            </Collapse>
            {!plateformSettings?.settings?.sidebarSettings?.sharedByMe &&
              <div className="sidebar-item hstack justify-content-between"
                onClick={() => setOpenSharedByMeData(!openSharedByMeData)}>
                <div className="hstack gap-2">
                  <CgArrowTopLeftR /> Shared By me
                </div>
                {openSharedByMeData ? <RiArrowDownWideLine /> : <RiArrowRightWideFill />}
              </div>
            }
            <Collapse in={openSharedByMeData}>
              <div className="ms-3">
                <div
                  className={`group-item ${groupId === "sharedByMe" ? "active" : ""}`}
                  onClick={() => {
                    setActiveItem("sharedByMe");
                    setGroupId("sharedByMe");
                    setCategoryId("")
                  }}>
                  <span><BsShieldLock /> Vaults</span>
                </div>
                {currentUserData?.loginAccountId &&
                  <>
                    {sharedByMeGroupList.map((g) => (
                      <div key={g.groupId}
                        className={`group-item ${((activeItem === "sharedByMeGroups") && (groupId === g.groupId)) ? "active" : ""}`}
                        onClick={() => {
                          setActiveItem("sharedByMeGroups");
                          setGroupId(g.groupId);
                          setCategoryId("")
                        }}>
                        <span><MdOutlineCategory /> {g.groupName}</span>
                      </div>
                    ))}
                  </>
                }
              </div>
            </Collapse>
          </div>
          {(!plateformSettings?.settings?.sidebarSettings?.group && currentUserData?.loginAccountId) &&
            <>
              <AddGroup
                Show={!toggles.toggle}
                Hide={toggles.setToggle}
                isDark={isDark}
                Title={`Add New Group`}
                setUpdator={setUpdator}
                auth={auth}
              />
              <UpdateGroup
                Show={!toggles.toggle1}
                Hide={toggles.setToggle1}
                isDark={isDark}
                Title={`Update Group`}
                groupId={groupId}
                setUpdator={setUpdator}
                auth={auth}
                groupData={groupData}
              />
              <GroupShareWithMember
                Show={!toggles.toggle2}
                Hide={toggles.setToggle2}
                isDark={isDark}
                Title={`Share with`}
                groupId={groupId}
                auth={auth}
                groupData={groupData}
                currentUserData={currentUserData}
              />
              <ShareList
                isDark={isDark}
                Show={!toggles.toggle5}
                Hide={toggles.setToggle5}
                Title="Share List"
                groupId={groupId}
                groupData={groupData}
                auth={auth}
              />
              <DeletedGroups
                Show={!toggles.toggle3}
                Hide={toggles.setToggle3}
                isDark={isDark}
                Title={`Deleted Group`}
                deleteGroup={deleteGroup}
                deletedGroupList={deletedGroupList}
                auth={auth}
                softDeleteRestoreGroup={softDeleteRestoreGroup}
              />
              <UpdatedActivity
                Show={!toggles.toggle4}
                Hide={toggles.setToggle4}
                isDark={isDark}
                itemData={""}
                auth={auth}
              />
            </>
          }
        </>
      }
      {!plateformSettings?.settings?.sidebarSettings?.system &&
        <>
          <div className="sidebar-section-title">{`System`}</div>
          <div className="sidebar-list">
            {currentUserData?.userType === "direct" &&
              <div onClick={() => { setActiveItem("auditHistory"); setGroupId("auditHistory"); setCategoryId("") }}
                className={`sidebar-item ${groupId === "auditHistory" ? "active" : ""}`}>
                <AiOutlineAudit /> Audit History
              </div>
            }
            {!plateformSettings?.settings?.sidebarSettings?.archive &&
              <div onClick={() => { setActiveItem("archived"); setGroupId("archived"); setCategoryId("") }}
                className={`sidebar-item ${groupId === "archived" ? "active" : ""}`}>
                <IoArchiveOutline /> Archive
              </div>
            }
            {!plateformSettings?.settings?.sidebarSettings?.trash &&
              <div onClick={() => { setActiveItem("trash"); setGroupId("trash"); setCategoryId("") }}
                className={`sidebar-item ${groupId === "trash" ? "bg-danger text-white" : "text-danger"}`}>
                <FaRegTrashCan /> Trash
              </div>
            }
          </div>
        </>
      }
    </aside>
  );
};

export default Sidebar;
